import React, { useState, useEffect, useCallback } from 'react'
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useDropzone } from 'react-dropzone';
import { S3ClientForUserApplications } from "../../../utils/s3Config";

function StatementOfFocus(props) {

	const { removeFile, updateForm, statementOfFocus, isStatementImage } = props;

	const [state, setState] = useState({
		statementLoader: false,
		statementFileName: ''
	})

	const onDrop = useCallback((acceptedFiles) => {
		setState({ ...state, statementLoader: true })
		// Do something with the files
		if (acceptedFiles && acceptedFiles.length > 0) {
			let file = acceptedFiles[0];
			if (file.length === 0) {
				toastr.error('Error', 'Please upload correct file');
				return;
			}
			if (file.size > 5000000) {
				toastr.error('Error', 'Please upload file less than 5MB');
				return;
			}

			S3ClientForUserApplications
				.uploadFile(file, new Date().getTime())
				.then(data => {
					updateForm('statementOfFocus', data && data.location ? data.location : null)
					state.isStatementImage = file.type == "image/jpeg" || file.type == "image/png";
					state.statementFileName = file.name || 'File'
					setState({ ...state, statementLoader: false })
				})
				.catch(err => {
					toastr.error('Error', 'Focus of Statement Uploading Fail');
					setState({ ...state, statementLoader: false })
				})
		}
		else {
      setState({ ...state, statementLoader: false })
      toastr.error('Error', 'Invalid File Type. PDF only');
    }
	}, [])

	const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, accept: '.pdf' });

	return (
		<>
			<div className="sub-heading app-info">
				Statement of Focus
			</div>
			<div className="field-label">
				Please submit a two-page Statement of Focus. This statement should identify the level of prior theological education you bring, indicate the objectives that you intend to accomplish through your study and note the kinds of courses that would be in pursuit of these objectives.
			</div>
			{state.statementLoader && <img src={`/icons/loading.svg`} style={{ height: '25px', marginLeft: '10px', backgroundColor: '#000' }} />}
			<div className="input-group">

				<div className="drag-block">
					<div {...getRootProps()}>
						<input {...getInputProps()} />
						{
							isDragActive ?
								<p>Drag & Drop a File or Click to Choose</p> :
								<p>Drag & Drop a File or Click to Choose</p>
						}
					</div>
				</div>
				{
					statementOfFocus &&
					<ul className="multi-images">
						<li>
							<span>
							{/* {!isStatementImage && <h6 className="file-title" alt="Statement of Focus">{state.statementFileName}</h6> } */}
								{isStatementImage ?
									<img src={statementOfFocus} alt="Statement of Focus" />
								:
									<img className="doc-icon" src="/icons/file-icon.svg"/>
								}
								<div className="thumb_overlay">
									<div className="thumb_cross" onClick={() => removeFile('statement')}>
										✕
									</div>
								</div>
							</span>
						</li>
					</ul>
				}
			</div>
			{statementOfFocus === false && <div className="field-error">Must add Focus of Statement</div>}
		</>
	);
}

export default StatementOfFocus;
